import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "placement", "isOpen", "trigger", "delay", "usePortal", "visibleArrow", "onVisibleChange"];
import React from 'react';
import OverlayTrigger from '@uiw/react-overlay-trigger';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (function (props) {
  if (props === void 0) {
    props = {};
  }
  var {
      prefixCls = 'w-tooltip',
      className,
      placement = 'top',
      isOpen = false,
      trigger,
      delay,
      usePortal = true,
      visibleArrow = true,
      onVisibleChange
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [prefixCls, className, !visibleArrow ? 'no-arrow' : null].filter(Boolean).join(' ').trim();
  return /*#__PURE__*/_jsx(OverlayTrigger, _extends({
    usePortal: usePortal,
    isOpen: isOpen,
    trigger: trigger,
    delay: delay,
    onVisibleChange: onVisibleChange,
    placement: placement
  }, other, {
    overlay: /*#__PURE__*/_jsxs("div", {
      className: cls,
      children: [visibleArrow && /*#__PURE__*/_jsx("div", {
        className: prefixCls + "-arrow"
      }), /*#__PURE__*/_jsx("div", {
        className: prefixCls + "-inner",
        children: props.content
      })]
    }),
    children: typeof props.children === 'object' ? props.children : /*#__PURE__*/_jsx("span", {
      children: props.children
    })
  }));
});